import { Component, OnInit, Input, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { LotePresupuestoEstado } from 'src/app/models/entities/lote-presupuesto-estado';
import { LotePresupuestoService } from 'src/app/services/lote-presupuesto.service';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { take, map } from 'rxjs/operators';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import { LoaderService } from 'src/app/services/loader.service';
interface EstadoPresupuesto {
  clave: string;
  nombreEstado: string;
  modificado: number;
  totalEjercido: number;
  subEjercicio: number;
}

interface sumaPresupuesto {
  pef: number;
  modificadoSia: number;
  calendario: number;
  ejercidoSia: number;
  ejercidoSiaff: number;
  totalEjercido: number;
  calendarioVsTotalEjercido: number;
}
@Component({
  selector: 'detalle-presupuesto-estado',
  templateUrl: './detalle-presupuesto-estado.component.html',
  styleUrls: ['./detalle-presupuesto-estado.component.scss']
})
export class DetallePresupuestoEstadoComponent implements OnChanges {

  public loteRuralesPresupuestoEstado: LotePresupuestoEstado;
  public loteFederalesPresupuestoEstado: LotePresupuestoEstado;
  public sumaFederalesPresupuesto: sumaPresupuesto;
  public sumaRuralesPresupuesto: sumaPresupuesto;
  public sumaTotalPresupuesto: sumaPresupuesto;
  public infoCargada: boolean = false;
  @Input('estadoPresupuestoSeleccionado')
  public estadoPresupuestoSeleccionado: EstadoPresupuesto;
  public catUnidadesResponsables: UnidadResponsable[] = [];
  public nombreEstado: string;
  public meses: string[] = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  @Input('mostrarRurales')
  public mostrarRurales: boolean;

  @Input('mostrarFederales')
  public mostrarFederales: boolean;
  constructor(
    private catalogoService: CatalogoService,
    private lotePresupuestoService: LotePresupuestoService
  ) { }

  public async cargarPresupuestoRuralesPorEstado() {
    this.lotePresupuestoService.findByKeyCatDireccion('0').pipe(
      take(1),
      map((lotePresupuesto: LotePresupuesto) => {
        let presupuestosEstados: PresupuestoEstado[] = lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.filter((pe: PresupuestoEstado) => pe.ur === this.estadoPresupuestoSeleccionado.clave);
        return {
          anioPef: lotePresupuesto.lotePresupuestoEstado.anioPef,
          finMes: lotePresupuesto.lotePresupuestoEstado.finMes,
          inicioMes: lotePresupuesto.lotePresupuestoEstado.inicioMes,
          metaAnioPef: lotePresupuesto.lotePresupuestoEstado.metaAnioPef,
          presupuestosEstados
        } as LotePresupuestoEstado;
      })
    ).subscribe(
      (lotePresupuestoEstado: LotePresupuestoEstado) => {
        this.loteRuralesPresupuestoEstado = lotePresupuestoEstado;
        let sumaPresupuestoRurales: any = {};
        sumaPresupuestoRurales.pef = this.loteRuralesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.pef, 0);
        sumaPresupuestoRurales.modificadoSia = this.loteRuralesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.modificadoSia, 0);
        sumaPresupuestoRurales.calendario = this.loteRuralesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.calendario, 0);
        sumaPresupuestoRurales.ejercidoSia = this.loteRuralesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.ejercidoSia, 0);
        sumaPresupuestoRurales.ejercidoSiaff = this.loteRuralesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.ejercidoSiaff, 0);
        sumaPresupuestoRurales.totalEjercido = this.loteRuralesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.totalEjercido, 0);
        sumaPresupuestoRurales.calendarioVsTotalEjercido = this.loteRuralesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.calendarioVsTotalEjercido, 0);
        this.sumaRuralesPresupuesto = sumaPresupuestoRurales;
      }
    );
  }


  public async cargarPresupuestoFederalesPorEstado() {
    this.lotePresupuestoService.findByKeyCatDireccion('1').pipe(
      take(1),
      map((lotePresupuesto: LotePresupuesto) => {
        let presupuestosEstados: PresupuestoEstado[] = lotePresupuesto.lotePresupuestoEstado.presupuestosEstados.filter((pe: PresupuestoEstado) => pe.ur === this.estadoPresupuestoSeleccionado.clave);
        return {
          anioPef: lotePresupuesto.lotePresupuestoEstado.anioPef,
          finMes: lotePresupuesto.lotePresupuestoEstado.finMes,
          inicioMes: lotePresupuesto.lotePresupuestoEstado.inicioMes,
          metaAnioPef: lotePresupuesto.lotePresupuestoEstado.metaAnioPef,
          presupuestosEstados
        } as LotePresupuestoEstado;
      })
    ).subscribe(
      async (lotePresupuestoEstado: LotePresupuestoEstado) => {
        this.loteFederalesPresupuestoEstado = lotePresupuestoEstado;
        let sumaPresupuestoFederales: any = {};
        sumaPresupuestoFederales.pef = this.loteFederalesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.pef, 0);
        sumaPresupuestoFederales.modificadoSia = this.loteFederalesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.modificadoSia, 0);
        sumaPresupuestoFederales.calendario = this.loteFederalesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.calendario, 0);
        sumaPresupuestoFederales.ejercidoSia = this.loteFederalesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.ejercidoSia, 0);
        sumaPresupuestoFederales.ejercidoSiaff = this.loteFederalesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.ejercidoSiaff, 0);
        sumaPresupuestoFederales.totalEjercido = this.loteFederalesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.totalEjercido, 0);
        sumaPresupuestoFederales.calendarioVsTotalEjercido = this.loteFederalesPresupuestoEstado.presupuestosEstados.reduce((prev, curr) => prev + curr.calendarioVsTotalEjercido, 0);
        this.sumaFederalesPresupuesto = sumaPresupuestoFederales;
        await this.obtenerTotalPresupuestos();
      }
    );
  }

  public async obtenerTotalPresupuestos() {
    let sumaTotalPresupuesto: any = {};
    sumaTotalPresupuesto.pef = this.sumaFederalesPresupuesto.pef + this.sumaRuralesPresupuesto.pef;
    sumaTotalPresupuesto.modificadoSia = this.sumaFederalesPresupuesto.modificadoSia + this.sumaRuralesPresupuesto.modificadoSia;
    sumaTotalPresupuesto.calendario = this.sumaFederalesPresupuesto.calendario + this.sumaRuralesPresupuesto.calendario;
    sumaTotalPresupuesto.ejercidoSia = this.sumaFederalesPresupuesto.ejercidoSia + this.sumaRuralesPresupuesto.ejercidoSia;
    sumaTotalPresupuesto.ejercidoSiaff = this.sumaFederalesPresupuesto.ejercidoSiaff + this.sumaRuralesPresupuesto.ejercidoSiaff;
    sumaTotalPresupuesto.totalEjercido = this.sumaFederalesPresupuesto.totalEjercido + this.sumaRuralesPresupuesto.totalEjercido;
    sumaTotalPresupuesto.calendarioVsTotalEjercido = this.sumaFederalesPresupuesto.calendarioVsTotalEjercido + this.sumaRuralesPresupuesto.calendarioVsTotalEjercido;
    this.sumaTotalPresupuesto = sumaTotalPresupuesto;
    this.infoCargada = true;
  }

  async ngOnChanges() {
    if (this.catUnidadesResponsables.length === 0) {
      await this.obtenerCatalogos();
    }
    await this.cargarPresupuestoRuralesPorEstado();
    await this.cargarPresupuestoFederalesPorEstado();
    this.nombreEstado = this.catUnidadesResponsables.find((ur: UnidadResponsable) => ur.cve.toString() === this.estadoPresupuestoSeleccionado.clave).nombreEstado;


  }


  public async obtenerCatalogos(): Promise<void> {
    this.catUnidadesResponsables = await this.catalogoService.obtenerCatalogo<UnidadResponsable>(RutaCatalogoEnum.UNIDADES_RESPONSABLES).pipe(take(1)).toPromise();
  }
}
